module.exports = "<span class='tag'\n    [class.selected]=\"isSelected\"\n    (click)='switch($event)'>\n  {{label}}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/topic-filter/topic-filter.component.html
// module id = 447
// module chunks = 0